import {
  useId,
  type InputHTMLAttributes,
  type ReactNode,
  type Ref,
} from 'react';
import clsx from 'clsx';
import './Checkbox.css';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label: ReactNode;
  error?: boolean;
  ref?: Ref<HTMLInputElement>;
}

export function Checkbox({
  label,
  error,
  disabled,
  id,
  className,
  ref,
  ...rest
}: CheckboxProps) {
  const autoId = useId();
  const inputId = id ?? autoId;
  return (
    <label
      className={clsx('fluent-choice', className)}
      data-disabled={disabled || undefined}
      data-invalid={error || undefined}
      htmlFor={inputId}
    >
      <input
        ref={ref}
        id={inputId}
        type="checkbox"
        className="fluent-choice__native"
        disabled={disabled}
        aria-invalid={error || undefined}
        {...rest}
      />
      <span className="fluent-choice__box" aria-hidden="true">
        <span className="fluent-choice__tick">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12.5l4.5 4.5L19 7.5" />
          </svg>
        </span>
      </span>
      <span className="fluent-choice__label">{label}</span>
    </label>
  );
}
